const _temp0 = require("./img/content/dicelists_terminal.gif");
module.exports = {
  "dicelists_terminal": _temp0
}